










































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import ListMixin from "@/components/mixin/list-mixin";
import { mixins } from "vue-class-component";
import CreateCategory from "./create-category.vue";
import EditCategory from "./edit-category.vue";
import adminColumns from "./admin-category-columns";
import columns from "./category-columns";
import actionColumns from "@/views/components/action-column";
import _ from "lodash";

class PageCategoryRequest extends PageRequest {
  keyword: string;
  clientCode: string;
  isCategoryMaster: boolean;
}

@Component({
  components: { CreateCategory, EditCategory },
})
export default class Categories extends mixins(ListMixin, AbpBase) {
  edit() {
    this.editModalShow = true;
  }
  namespace = "category";
  clients = [];
  //filters
  pagerequest: PageCategoryRequest = new PageCategoryRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  get store() {
    return this.$store.state.category;
  }
  isClient() {
    return !_.isNil(this.$store.state.session.client);
  }
  isTenant() {
    return !_.isNil(this.$store.state.session.tenant);
  }
  get clientCode() {
    return this.isClient() ? this.$store.state.session.client.code : null;
  }
  get client() {
    return this.$store.state.session.client;
  }
  async getClients() {
    await this.$store
      .dispatch({
        type: "client/getListForSelect",
        data: {
          hasAllItem: true,
        },
      })
      .then(() => {
        this.clients = this.$store.state.client.clientsForSelect;
        this.pagerequest.clientCode =
          this.clients.length > 0 ? this.clients[0].code : "";
      });
  }
  get list() {
    var re = this.$store.state.category.list;
    var startIndex = (this.currentPage - 1) * this.pageSize;
    var index = 0;
    re.forEach(function(item) {
      item.orderNo = startIndex + index + 1;
      index++;
    });
    return re;
  }
  async exportToExcel() {
    this.preGetPage();
    await this.$store.dispatch({
      type: "category/export",
      data: this.pagerequest,
    });
  }
  create() {
    this.createModalShow = true;
  }
  editCategory(row) {
    this.$store.commit("category/edit", row);
    this.editModalShow = true;
  }
  removeCategory(row) {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("DeleteCategoryConfirm"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        await this.$store.dispatch({
          type: "category/delete",
          data: row,
        });
        this.showSuccessMsg("Success.DeleteCategorySucc");
        await this.getpage();
      },
    });
  }
  preGetPage() {
    if (this.isClient()) {
      this.pagerequest.clientCode = this.client.code;
    }
  }
  importCategories() {
    this.$router.push({ path: "../grpclient/import-category" });
  }
  showSuccessMsg(msg: string) {
    Util.showSuccessMsg(this, msg);
  }
  renderColumns() {
    if (this.isClient()) {
      return [...columns, ...actionColumns];
    }
    if (this.isTenant()) {
      return adminColumns.concat(columns);
    }
    return [...adminColumns.concat(columns), ...actionColumns];
  }
  get columns() {
    return [
      {
        title: this.L("Order"),
        width: 65,
        key: "orderNo",
      },
      ...this.renderColumns(),
    ];
  }
  methods = {};
  async created() {
    await this.getClients();
    await this.$store.dispatch({
      type: "category/getParentListForSelect",
      data: {
        isMaster: !this.isClient(),
      },
    });
  }
}
